import { NodeProps } from "reactflow";
import NodeCard from "../NodeCard";
import { FlowModuleItemType } from "@packages/flow-core/module";
import { memo, useMemo } from "react";
import Divider from "../Divider";
import styles from "./index.less";
import RenderInput from "../render/RenderInput";
import RenderOutput from "../render/RenderOutput";
import { useFlow } from "../FlowEdit/useFlow";
import RenderToolInput from "../render/RenderToolInput";
import SelectedMcp from "../render/RenderInput/templates/SelectedMcp";

export default memo(function NodeSimple({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const { inputs, moduleId, outputs } = data;
  const { splitToolInputs } = useFlow();
  const { toolInputs, commonInputs } = splitToolInputs(inputs, moduleId);

  const visibleInputs = useMemo(
    () => commonInputs.filter((item) => item.type !== "hidden"),
    [inputs]
  );

  return (
    <NodeCard minWidth={350} selected={selected} {...data}>
      {toolInputs.length > 0 && (
        <>
          <Divider text="工具输入" />
          <div className={styles.content}>
            <RenderToolInput moduleId={moduleId} inputs={toolInputs || []} />
          </div>
        </>
      )}
      {visibleInputs?.length > 0 && (
        <>
          <Divider text="输入" />
          <div className={styles.content}>
            <RenderInput
              flowInputList={visibleInputs}
              CustomComponent={{
                mcp: SelectedMcp,
              }}
              moduleId={moduleId}
            />
          </div>
        </>
      )}
      {outputs?.length > 0 && (
        <>
          <Divider text="输出" />
          <div className={styles.content}>
            <RenderOutput flowOutputList={outputs} moduleId={moduleId} />
          </div>
        </>
      )}
    </NodeCard>
  );
});
